import React, { useEffect, useMemo, useState } from 'react';
import { TextField } from '@mui/material';
import { debounce } from 'throttle-debounce';

interface SearchProps {
  filter(searchTerm: string): void;
  parentSearchTerm?: string;
  debounceMs?: number;
  minSearchLength?: number;
}

export function SearchField({ filter, parentSearchTerm, debounceMs = 300, minSearchLength = 0 }: SearchProps) {
  const [searchTerm, setSearchTerm] = useState(parentSearchTerm === undefined ? '' : parentSearchTerm);
  const getSubmittedSearchTerm = (value: string) => {
    const trimmedValue = value.trim();
    return trimmedValue.length >= minSearchLength ? trimmedValue : '';
  };
  const triggerFilter = useMemo(
    () => debounce(debounceMs, (value: string) => filter(getSubmittedSearchTerm(value))),
    [debounceMs, filter, minSearchLength],
  );

  useEffect(() => {
    return () => triggerFilter.cancel();
  }, [triggerFilter]);

  const handleFilterInput = (event) => {
    let s = event.target.value;
    if (!s) {
      sessionStorage.setItem('searchTerm', '');
    }
    setSearchTerm(s);
    triggerFilter(s);
  };

  const submitSearch = () => {
    triggerFilter.cancel();
    filter(getSubmittedSearchTerm(searchTerm));
  };

  return (
    <TextField
      margin="dense"
      name="searchTerm"
      label="Søk"
      type="text"
      variant="standard"
      onChange={handleFilterInput}
      onBlur={submitSearch}
      onKeyDown={(event) => {
        if (event.key === 'Enter') submitSearch();
      }}
      value={searchTerm}
      fullWidth
    />
  );
}
